const CONDITIONS_GROUND = ['Damp', 'Dry', 'Flooded', 'Muddy', 'Snow', 'Wet', 'Other']

const CONDITIONS_WEATHER = ['Clear', 'Cloudy', 'Light Rain', 'Rain', 'Snowing', 'Other']

export { CONDITIONS_GROUND, CONDITIONS_WEATHER }
